import { call, takeLatest, put, } from 'redux-saga/effects';
import {   getIacmLocationCall,  getIacmLocationSuccess, getIacmLocationFailure, getIacmActivateLocationCall, getIacmActivateLocationSuccess, getIacmActivateLocationFailure } from '../actions/checkmateAuthorizationAction';
import {  makeIacmLocationApi, makeIacmActivateLocationApi } from '../../api/api';

export function* getIacmLocation(action){
   try{
      const code =  action.payload && action.payload.codeToken && action.payload.codeToken.code;      
      const response = yield call(makeIacmLocationApi, code);
      if (response?.status === 200) {
         yield put(getIacmLocationSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(getIacmLocationFailure(response)) : yield put(getIacmLocationFailure(response.response));
      }
   }catch(e){
      yield put(getIacmLocationFailure(e.message));
   }
}

export function* getIacmActivateLocation(action){
   try{
      const locationId =  action && action.payload && action.payload.codeId && action.payload.codeId.storeLocationId;
      const accessTokenValue =  action && action.payload && action.payload.codeId && action.payload.codeId.accessToken;
      const response = yield call(makeIacmActivateLocationApi, locationId, accessTokenValue);
      if (response?.status === 200) {
         yield put(getIacmActivateLocationSuccess(response.data));
      } else {
         response?.code === 'ECONNABORTED' ? yield put(getIacmActivateLocationFailure(response)) : yield put(getIacmActivateLocationFailure(response.response));
      }
   }catch(e){
      yield put(getIacmActivateLocationFailure(e.message));
   }
}

function* checkmateAuthorizationSaga() {
   yield takeLatest(getIacmLocationCall, getIacmLocation);
   yield takeLatest(getIacmActivateLocationCall, getIacmActivateLocation);
}

export default checkmateAuthorizationSaga;
